const sectionIconsOpacity = {
  selected: 1,
  unselected: 0.64,
} as const;

export default sectionIconsOpacity;
